import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AfterViewInit, booleanAttribute, ChangeDetectionStrategy, Component, computed, DestroyRef, input, viewChild} from "@angular/core";
import {GruppeMedlemListeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatSelect, MatSelectModule} from "@angular/material/select";
import {AvatarKomponent} from "../avatar/avatar";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldControl} from "@angular/material/form-field";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {harSammeId, leggEntitetTilListeDersomIkkeInkludert} from "felles-ng2/modell/modellHjelpere";
import {MatFormFieldControlProxy} from "../../material/MatFormFieldControlProxy";
import {Subject} from "rxjs";
import {TranslateModule} from "@ngx-translate/core";
import {medlemmerGruppertPåPrimærRolle, primærMedlemsrolle} from "felles-ng2/modell/medlemModellHjelpere";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MedlemListevisningKompaktKomponent} from "web-ng2/moduler/medlem/komponenter/medlem-listevisning-kompakt/medlem-listevisning-kompakt";

const debug = initDebugger('VelgMedlemKomponent');


/** Viser dropdown med medlemmer.
 * <pre>
 * Fungerer med Ng reactive form via ([(skjemakontroll)]="...").
 * Fungerer med <mat-form-field> fra Material.
 *
 * MERK at vi ikke implementerer ControlValueAccessor fra angular.forms, så komponenten vil ikke fungere med
 * [(ngModel)]="..." eller [formControl]="...".
 * </pre>
 */
@Component({
    selector: 'velg-medlem',
    templateUrl: 'velg-medlem.html',
    styleUrl: 'velg-medlem.scss',
    host: {'[class]': 'stil()'},
    providers: [{
        provide: MatFormFieldControl,
        useFactory: (komponent: VelgMedlemKomponent) => new MatFormFieldControlProxy(() => komponent.nedtrekksmeny(), komponent.stateChanges),
        deps: [VelgMedlemKomponent]
    }],
    imports: [
        MatSelectModule,
        AvatarKomponent,
        ReactiveFormsModule,
        TranslateModule,
        MedlemListevisningKompaktKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VelgMedlemKomponent implements AfterViewInit {

    private nedtrekksmeny = viewChild.required(MatSelect);

    medlemmer = input.required<GruppeMedlemListeModell[]>();
    skjemakontroll = input.required<FormControl<GruppeMedlemListeModell | null>>();
    tillatIngenValgt = input(true, {transform: booleanAttribute});
    placeholder = input('');
    stil = input<'kun-avatar' | 'avatar-og-navn'>('avatar-og-navn');

    medlemmerGruppert = computed(() => medlemmerGruppertPåPrimærRolle(this.beregnTilgjengeligeMedlemmer()));
    readonly erValgt = harSammeId;

    private readonly stateChanges = new Subject<void>();

    constructor(private destroyRef: DestroyRef) {
    }

    ngAfterViewInit(): void {
        this.nedtrekksmeny().stateChanges
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.stateChanges.next())
    }

    aktivRolletittel(medlem: GruppeMedlemListeModell): string {
        return primærMedlemsrolle(medlem)?.tittel ?? '';
    }

    //hjelpemetoder

    private beregnTilgjengeligeMedlemmer(){
        const angitteMedlemmer = this.medlemmer();
        const initieltValgtMedlem = this.skjemakontroll().value;
        if (erNil(initieltValgtMedlem)) return angitteMedlemmer;
        return leggEntitetTilListeDersomIkkeInkludert(initieltValgtMedlem, angitteMedlemmer);
    }
}

